import { render, staticRenderFns } from "./MarketPromoTab.vue?vue&type=template&id=c47575a8&"
import script from "./MarketPromoTab.vue?vue&type=script&lang=js&"
export * from "./MarketPromoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports